import React, { useEffect, useRef, useState } from "react";

export function InputTimeGroup({ id, value, onChange, placeholder, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedHour, setSelectedHour] = useState(
    value?.split(":")[0] || "00",
  );

  const [selectedMinute, setSelectedMinute] = useState(
    value?.split(":")[1] || "00",
  );

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleHourClick = (hour) => {
    setSelectedHour(hour);

    onChange({
      target: {
        name: id,
        value: `${hour}:${selectedMinute}`,
      },
    });
  };

  const handleMinuteClick = (minute) => {
    setSelectedMinute(minute);

    onChange({
      target: {
        name: id,
        value: `${selectedHour}:${minute}`,
      },
    });

    setIsOpen(false);
  };

  return (
    <div ref={wrapperRef} className="input-time-group">
      <input
        id={id}
        type="text"
        className="form-control"
        value={`${selectedHour}:${selectedMinute}`}
        placeholder={placeholder || "00:00"}
        readOnly
        disabled={disabled}
        onClick={() => setIsOpen(true)}
      />

      {isOpen && (
        <div className="input-time-popup">
          <div className="input-time-column input-time-column-left">
            {Array.from({ length: 24 }, (_, i) => {
              const hour = String(i).padStart(2, "0");

              return (
                <div
                  key={hour}
                  onClick={() => handleHourClick(hour)}
                  className={`input-time-item ${
                    selectedHour === hour ? "input-time-item-selected" : ""
                  }`}
                >
                  {hour}
                </div>
              );
            })}
          </div>

          <div className="input-time-column">
            {Array.from({ length: 60 }, (_, i) => {
              const minute = String(i).padStart(2, "0");

              return (
                <div
                  key={minute}
                  onClick={() => handleMinuteClick(minute)}
                  className={`input-time-item ${
                    selectedMinute === minute ? "input-time-item-selected" : ""
                  }`}
                >
                  {minute}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
